import React from "react";
import "./Dashboard.css"; // Import the CSS file
import { FaMoneyBillAlt, FaShoppingBag, FaChartPie } from "react-icons/fa";
import BarGraph from "../Users/BarGraph";
import imageUrl from "../../resources/images/WhatsApp Image 2024-01-17 at 3.28.25 PM (1).jpeg";
import imageUrl2 from "../../resources/images/WhatsApp Image 2024-01-17 at 3.28.25 PM (1).jpeg";

const Dashboard = () => {
  return (
    <div>
      <div>
        <div className="dashboard_card-display">
          <div className="dashboard_card">
            <FaMoneyBillAlt className="dashboard_icon" />

            <div className="dashboard_content">
              <h2>Gemstone</h2>
              <p>5 items of gemstone is on sale.</p>
            </div>
          </div>
          <div className="dashboard_card">
            <FaShoppingBag className="dashboard_icon" />
            <div className="dashboard_content">
              <h2>Industrial Materials</h2>
              <p>3 items of industrial materials for demo.</p>
            </div>
          </div>
          <div className="dashboard_card">
            <FaChartPie className="dashboard_icon" />
            <div className="dashboard_content">
              <h2>Total</h2>
              <p>Now 8 products on Live.</p>
            </div>
          </div>
        </div>
      </div>
      <div className="dashboard_bottom_container">
        <div>{/* <BarGraph /> */}</div>
        <div>
          <div className="dash_colorful-card">
            <div className="img_dash_cont">
              <img src={imageUrl} alt="Card" className="dash_card-image" />
              <img src={imageUrl2} alt="Card" className="dash_card-image" />
            </div>
            <div className="dash_card-description">
              <p>
                A gemstone (also called a fine gem, jewel, precious stone,
                <br />
                semiprecious stone, or simply gem) is a piece of mineral crystal
                <br />
                which, when cut or polished, is used to make jewelry or other
                <br />
                adornments
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
